import { Divider, Drawer, IconButton, MenuList, MenuItem, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { RoutePath } from '../util/Routes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerPaper: {
      zIndex: 0,
      marginTop: '64px',
      height: 'calc(100% - 64px)',
    },
    closeIcon: {
      position: 'fixed',
      color: '#ffffff',
      marginLeft: '310px',
      marginTop: theme.spacing(3),
    },
    iconSize: {
      fontSize: '1.8em',
    },
    mainGrid: {
      paddingTop: 64,
      width: 310,
      [theme.breakpoints.up('md')]: {
        paddingTop: 0,
      },
    },
    navList: {
      width: '100%',
      padding: 0,
    },
    sectionHeader: {
      letterSpacing: 1.5,
      fontSize: 12,
      padding: theme.spacing(2, 2, 0.5, 2),
      color: theme.palette.text.secondary,
    },
    menuItem: {
      height: 55,
      textDecoration: 'none',
      color: theme.palette.text.primary,
      '&>.MuiDivider-root': {
        width: 'calc(100% - 12px)',
        position: 'absolute',
        top: 0,
        left: 0,
        marginLeft: 12,
      },
    },
    menuItemIcon: {
      marginRight: theme.spacing(2),
      color: theme.palette.uxGrey.main,
    },
  }),
);

interface Props {
  mobileOpen: boolean;
  onMobileClose: () => void;
}

const ApteanAdminMenu: React.FC<Props> = ({ mobileOpen, onMobileClose }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesMdDown = useMediaQuery(theme.breakpoints.down('md'));

  const drawerContent = (
    <div className={classes.mainGrid}>
      {matchesMdDown && mobileOpen && (
        <IconButton className={classes.closeIcon} onClick={onMobileClose} data-cy="admin-menu-close" size="large">
          <CloseIcon className={classes.iconSize} />
        </IconButton>
      )}
      <Typography className={classes.sectionHeader}>MERCHANTS</Typography>
      <MenuList className={classes.navList}>
        <MenuItem component={NavLink} className={classes.menuItem} to="/" exact data-cy="nav-all-merchants">
          <Divider />
          <ListAltIcon className={classes.menuItemIcon} />
          All merchants
        </MenuItem>
      </MenuList>
      <Typography className={classes.sectionHeader}>ADMINISTRATION</Typography>
      <MenuList className={classes.navList}>
        <MenuItem component={NavLink} className={classes.menuItem} to={RoutePath.ApteanAdminUsers} data-cy="nav-manage-aptean-users">
          <Divider />
          <ManageAccountsIcon className={classes.menuItemIcon} />
          Manage Aptean Users
        </MenuItem>
      </MenuList>
    </div>
  );

  return (
    <Drawer
      open={matchesMdDown ? mobileOpen : true}
      variant={matchesMdDown ? 'temporary' : 'persistent'}
      anchor="left"
      classes={{ paper: matchesMdDown ? '' : classes.drawerPaper }}
      onClose={matchesMdDown ? onMobileClose : undefined}
      data-cy="aptean-admin-menu"
    >
      {drawerContent}
    </Drawer>
  );
};

export default ApteanAdminMenu;
